import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

// Collapsible process group for the deal page. Children mount on first open and
// stay mounted (hidden) afterwards so card state and fetched data survive toggling.
export function ProcessSection({ id, icon: Icon, iconClass, title, subtitle, badges, open, onToggle, children, testid }) {
  const [everOpened, setEverOpened] = useState(open);
  useEffect(() => { if (open) setEverOpened(true); }, [open]);
  return (
    <div id={id} className="scroll-mt-24 bg-card border border-border rounded-sm overflow-hidden" data-testid={testid}>
      <button onClick={onToggle} aria-expanded={open} data-testid={`${testid}-toggle`}
        className="w-full flex items-center gap-3 p-4 text-left hover:bg-secondary/20 transition-colors">
        <span className={`w-8 h-8 rounded-sm flex items-center justify-center shrink-0 transition-colors ${open ? 'bg-blue-500/15' : 'bg-secondary'}`}>
          <ChevronDown className={`w-4 h-4 text-blue-400 transition-transform duration-200 ${open ? '' : '-rotate-90'}`} />
        </span>
        {Icon && <Icon className={`w-4 h-4 shrink-0 ${iconClass || 'text-foreground/60'}`} strokeWidth={1.7} />}
        <span className="font-heading text-base text-foreground shrink-0">{title}</span>
        {subtitle && <span className="hidden md:block text-[11px] text-muted-foreground truncate">{subtitle}</span>}
        <span className="ml-auto flex items-center gap-1.5 flex-wrap justify-end">{badges}</span>
      </button>
      {everOpened && (
        <div className={open ? 'px-3 sm:px-4 pb-4 pt-4 space-y-6 border-t border-border' : 'hidden'}>
          {children}
        </div>
      )}
    </div>
  );
}

export const GroupChip = ({ children, tone = '' }) => (
  <span className={`text-[9px] font-mono border rounded px-1.5 py-0.5 whitespace-nowrap ${tone || 'border-border bg-secondary/50 text-muted-foreground'}`}>
    {children}
  </span>
);
